"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SourceMapSourcesMode = void 0;
const Utils_1 = require("../../utils/Utils");
exports.SourceMapSourcesMode = Utils_1.Utils.makeEnum({
    Sources: 'sources',
    SourcesContent: 'sources-content'
});
